import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { IUserSignUpReportData } from "../../interfaces/analytics";

const useGetUserSignUpReport = (filterQuery: string) => {
    const queryFn = async (): Promise<IUserSignUpReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/user-sign-up-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['user-sign-up-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetUserSignUpReport;